import React from "react";

export default function PublicRoute ({ children }) {
    return children ;
};
